import { Component } from '@angular/core';
import { formatTime } from 'app/core/shared/helper/time.helper';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { handleFormatDate } from 'app/core/shared/helper/date.helper';
import { ActivatedRoute } from '@angular/router';
import { WPBService } from 'app/modules/work-planning-budget/services/work-planning-budget.service';
import module from "app/modules/work-planning-budget/wpb.module";

@Component({
  selector: 'app-wpb-edit',
  templateUrl: './wpb-edit.component.html',
  standalone: true,
  imports: module,
  styleUrls: ['./wpb-edit.component.scss']
})
export class WpbEditPage {
  public wpbForm: FormGroup
  public initialFormValues: any;
  public wpbRecord: any

  private wpbId = this.route.snapshot.paramMap.get('id');

  ngOnInit() {
    this.wpbForm = this.initializeForm()
    this.getWpb()

    this.onChangeStatus()
  }

  constructor(
    private fb: FormBuilder,
    public location: Location,
    private wpbService: WPBService,
    private route: ActivatedRoute,
  ) { }


  initializeForm() {
    return this.fb.group({
      wpbId: this.wpbId,
      cmId: '',
      wellStringId: '',
      platformShortName: [{ value: '', disabled: true }],
      platformLongName: [{ value: '', disabled: true }],
      fieldShortName: [{ value: '', disabled: true }],
      fieldLongName: [{ value: '', disabled: true }],
      wellShortName: [{ value: '', disabled: true }],
      wellLongName: [{ value: '', disabled: true }],
      stringShortName: [{ value: '', disabled: true }],
      stringLongName: [{ value: '', disabled: true }],
      stringIndicatorShortName: "",
      submissionDate: "",
      submissionYear: 0,
      submissionType: "",
      integrityIssue: "",
      proposalDesc: "",
      planExecutionDate: "",
      planCostRmMil: null,
      actualCostRmMil: null,
      remark: "",
      wpbStatus: "",
      inputBy: [{ value: '', disabled: true }],
      inputDate: [{ value: new Date().toISOString(), disabled: true }],
      updateBy: [{ value: '', disabled: true }],
      updateDate: [{ value: new Date().toISOString(), disabled: true }],
    })
  }

  private getWpb() {
    this.wpbService.getWpbRecord(this.wpbId).subscribe((res) => {
      if (res) {
        this.wpbRecord = res.data

        this.wpbForm.patchValue({
          wpbId: this.wpbId,
          cmId: this.wpbRecord.cmId,
          wellStringId: this.wpbRecord.wellStringId,
          platformShortName: this.wpbRecord.platformShortName,
          platformLongName: this.wpbRecord.platformLongName,
          fieldShortName: this.wpbRecord.fieldShortName,
          fieldLongName: this.wpbRecord.fieldLongName,
          wellShortName: this.wpbRecord.wellShortName,
          wellLongName: this.wpbRecord.wellLongName,
          stringShortName: this.wpbRecord.stringShortName,
          stringLongName: this.wpbRecord.stringLongName,
          stringIndicatorShortName: this.wpbRecord.stringIndicatorShortName,
          submissionDate: this.wpbRecord.submissionDate,
          submissionYear: this.wpbRecord.submissionYear,
          submissionType: this.wpbRecord.submissionType,
          integrityIssue: this.wpbRecord.integrityIssue,
          proposalDesc: this.wpbRecord.proposalDesc,
          planExecutionDate: this.wpbRecord.planExecutionDate,
          planCostRmMil: this.wpbRecord.planCostRmMil,
          actualCostRmMil: this.wpbRecord.actualCostRmMil,
          remark: this.wpbRecord.remark,
          wpbStatus: this.wpbRecord.wpbStatus,
          inputBy: this.wpbRecord.inputBy,
          inputDate: handleFormatDate(this.wpbRecord.inputDate, false),
          updateBy: this.wpbRecord.updateBy,
          updateDate: handleFormatDate(this.wpbRecord.updateDate, false),
        })

        this.initialFormValues = { ...this.wpbForm.getRawValue() }
      }
    })
  }

  private onChangeStatus() {
    this.wpbForm.get('wpbStatus').valueChanges.subscribe((res) => {
      const actualCost = this.wpbForm.get('actualCostRmMil');

      if (res === 'Closed') {
        actualCost.enable();
        actualCost.setValidators([Validators.required]);
      } else {
        actualCost.disable();
        actualCost.clearValidators();
      }

      actualCost.updateValueAndValidity();
    })
  }

  getTime(recordDate) {
    let date = new Date(recordDate)
    return formatTime(date)
  }

  editWpb() {
    this.wpbService.createUpdateWpb(this.wpbForm.getRawValue())
      .subscribe((res) => {
        if (res) {
          this.location.back()
        }
      })
  }

  // Method to check if the form values have changed
  hasFormChanged(): boolean {
    return JSON.stringify(this.initialFormValues) !== JSON.stringify(this.wpbForm.getRawValue());
  }

  handleDate(date) {
    return handleFormatDate(date, true)
  }

  get updateBy() {
    return this.wpbForm.get('updateBy').value
  }

  get updateDate() {
    return this.wpbForm.get('updateDate').value
  }

}
